export default "__VITE_ASSET__DiVSA4kC__"